export default {"src":"/_next/static/media/right-arrow.f8ec43fc.svg","height":12,"width":15};